import { Group } from '@models/entities';

export function getValidationPageTitle(group: Group): string {
    let name = group.uniqueName;
    if (!!group.type) {
        name = `${name} (${group.type})`;
    }
    if (!!group.shortComment) {
        name = `${name} - ${group.shortComment}`;
    }
    return name;
}